module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq163-9f8c27baa5ba1975bb4161879818d9c1.jpg";